import React, { useState, useContext } from "react";
import logo from "./logo.png";
import { Alert, Button, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Login } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { httpService } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";

function UpdateRegistration() {
  const { setAlertData } = useContext(AlertContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [participant, setParticipant] = useState({});

  const getData = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data, error } = await httpService.post(
      "retrieveindividualregistration",
      participant
    );

    if (data) {
      navigate(`/updateregistration/${data._id}`);
    }

    if (error) {
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setLoading(false);
  };
  return (
    <div style={{ minHeight: "80vh" }} className="bg-light">
      <div className="d-flex justify-content-center">
        <div className="col-lg-5 bg-white p-5 rounded shadow-sm">
          <div className="text-center mb-4">
            <img src={logo} alt="logo" width="120" height="100" />
          </div>
          <div className="text-center mb-5">
            <h4 className="text-muted" style={{ fontWeight: "700" }}>
              {new Date().getFullYear()} JAMB POLICY MEETING REGISTRATION UPDATE
              PORTAL
            </h4>
          </div>
          <form onSubmit={getData}>
            <div className="mb-4">
              <TextField
                fullWidth
                label="Institution ID"
                onChange={(e) =>
                  setParticipant({
                    ...participant,
                    institutionId: e.target.value,
                  })
                }
              />
            </div>
            <div className="mb-4">
              <TextField
                onChange={(e) =>
                  setParticipant({
                    ...participant,
                    phoneNumber: e.target.value,
                  })
                }
                fullWidth
                label="Phone Number"
                helperText="The phone number you used in your registration"
              />
            </div>
            <div className="mb-5">
              <LoadingButton
                type="submit"
                endIcon={<Login />}
                variant="contained"
                fullWidth
                loadingPosition="end"
              >
                login
              </LoadingButton>
            </div>
          </form>
          <div className="mb-4">
            <Alert severity="info">
              <p>
                This portal is only usable for participants who have registered
                for the {new Date().getFullYear()} .{" "}
                <Button onClick={() => navigate("/")}>
                  click here to register
                </Button>
              </p>
            </Alert>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateRegistration;
